import React from 'react';
import { Divider as Component } from 'wix-ui-tpa/cssVars';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { classes } from './StepDivider.st.css';

export const StepDivider = () => (
  <Component className={classes.root} data-hook={VIEWER_HOOKS.STEP_DIVIDER} direction="horizontal" />
);
